import React from 'react';
import { SxProps, Theme, Link } from '@mui/material';
import { TodoItem } from './DashboardTodoTypes';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    marginTop: 3,
  },
  card: {
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    height: '100%',
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    cursor: 'pointer',
    border: {
      xs: '1px solid #E3E6E9',
      md: 'none',
    },
    boxShadow: {
      xs: '0px 2px 8px rgba(0, 0, 0, 0.05)',
      md: 'none',
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: '#F9F9F9',
      },
    },
  },
  accordionHeader: {
    fontFamily: 'InterMedium',
    fontWeight: 500,
    fontSize: '17.36px',
    lineHeight: '23.44px',
    color: '#3A155A',
  },
  menuPaper: {
    overflow: 'visible',
    mt: 1,
    borderRadius: '12px',
    border: '1px solid #E3E6E9',
  },
  actionText: {
    fontSize: '15.75px',
    fontFamily: 'InterMedium',
    fontWeight: 500,
    color: '#3A155A',
  },
  button: {
    backgroundColor: '#9135E0',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '8px',
    width: '125px',
    height: '38px',
    fontSize: '11px !important',
    fontWeight: 500,
    boxShadow: 'none',
    fontFamily: 'InterMedium !important',
    '&:hover': {
      backgroundColor: '#7E2BC4',
    },
    '&.Mui-disabled': {
      backgroundColor: '#9135E0',
      opacity: 0.8,
      cursor: 'not-allowed',
    },
  },
  laterButton: {
    backgroundColor: '#E3E6E9',
    color: '#3A155A',
    textTransform: 'none',
    borderRadius: '8px',
    width: '125px',
    height: '38px',
    fontSize: '11px !important',
    fontWeight: 500,
    boxShadow: 'none',
    fontFamily: 'InterMedium !important',
    '&:hover': {
      backgroundColor: '#D1D5D8',
    },
    '&.Mui-disabled': {
      backgroundColor: '#D1D5D8',
      color: '#3A155A',
      cursor: 'not-allowed',
    },
  },
};

export const getCardStyle = (index: number, total: number) => ({
  borderTop: '1px solid #E3E6E9',
  borderRight: '1px solid #E3E6E9',
  borderBottom: '1px solid #E3E6E9',
  borderLeft: {
    xs: '1px solid #E3E6E9',
    md: index % 2 === 0 ? '1px solid #E3E6E9' : 'none',
    lg: index === 0 ? '1px solid #E3E6E9' : 'none',
  },
  borderRadius: total === 1 ? '13.02px' : {
    xs: '13.02px',
    md:
      index === 0
        ? '13.02px 0 0 0'
        : index === 1
        ? '0 13.02px 13.02px 0'
        : index === total - 1
        ? '0 0 13.02px 13.02px'
        : 0,
    lg:
      index === 0
        ? '13.02px 0 0 13.02px'
        : index === total - 1
        ? '0 13.02px 13.02px 0'
        : 0,
  },
});

export const THEMES = {
  dashboard: {
    primary: '#9135E0',
    secondary: '#3A155A',
    hover: '#7E2BC4',
  },
  onboarding: {
    primary: '#1a73e8',
    secondary: '#1D2333',
    hover: '#1557b0',
  },
};

export const TODO_ITEMS: TodoItem[] = [
  {
    id: 1,
    title: 'PeopleFinders',
    actionTitle: 'Additional action needed:',
    titleActionText: 'Trigger Optout',
    actionItems: [
      <span key="optout">Click the <strong>&quot;trigger optout&quot;</strong> button below.</span>,
      <span key="email">You&apos;ll get an email from <Link href="mailto:customercare@peoplefinders.com" target="_blank" sx={{ color: '#9135E0' }}>customercare@peoplefinders.com</Link>.</span>,
      <span key="head">Head to this email and click <strong>&quot;Click here to fill out the records removal form&quot;</strong>.</span>,
      <span key="fill">Fill out the form with your full name, street address, city, state and any other information you are comfortable providing.</span>,
      <span key="done">Once you&apos;ve submitted the form, click the <strong>&quot;I&apos;ve done this&quot;</strong> button.</span>,
    ],
    buttonText: "I've done this",
  },
  {
    id: 2,
    title: 'Intelius',
    actionTitle: 'Additional action needed:',
    actionItems: [
      <span key="link">Click this <Link href="https://suppression.peopleconnect.us/login" target="_blank" sx={{ color: '#9135E0' }}>link</Link> to go to the Intelius opt out form.</span>,
      <span key="enter">Enter your email and follow instructions provided in order to submit the opt out.</span>,
      <span key="verify">Verify the opt out via either email or phone call.</span>,
      <span key="done">Once you&apos;ve submitted the opt out, click the <strong>&quot;I&apos;ve done this&quot;</strong> button.</span>,
    ],
    buttonText: "I've done this",
  },
  {
    id: 3,
    title: 'Data Broker Communications',
    actionTitle: 'Please note:',
    actionItems: [
      <span key="covers">Our service covers hundreds of data brokers on your behalf. While we handle most removals, some brokers may still contact you directly after we submit opt-out requests.</span>,
      <span key="check">Please check your inbox and spam folder regularly and reply promptly if additional information is requested so we can complete the removal process.</span>,
    ],
    buttonText: 'Acknowledged',
  },
];
